module.exports = __webpack_public_path__ + "static/img/B (21).d8c5430b.png";